import { render, staticRenderFns } from "./PropertyManagementReport.vue?vue&type=template&id=0528d412"
import script from "./PropertyManagementReport.vue?vue&type=script&lang=js"
export * from "./PropertyManagementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports